exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-chat-messages[data-v-24650924] {\n  background-color: #FFFBFA;\n}\n.chat-messages[data-v-24650924] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  height: 100vh;\n  scroll-behavior: smooth;\n  padding-bottom: 3rem;\n}\n.text-loading[data-v-24650924] {\n  font-size: 140%;\n  font-weight: 400;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-24650924","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/chatBooking/Index.vue
// module id = 2197
// module chunks = 0